'use client'
import { Maybe, ProductTypeProps } from '.'
import ProductCardTitle from '../product-card-title'
import type { Props } from './product-card-gallery'
import { handeOnClickProduct } from './utils'
import { Product as VariantCProduct } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import type { Props as HeadingProps } from '@dustin-web/microsite-components/src/heading'

type TitleProps = {
  digitalDataIndex: Props['digitalIndex']
  digitalDataOrigin: Props['digitalDataOrigin']
  product: Maybe<ProductTypeProps> | VariantCProduct
  ticket: string
  className?: string
  compact?: boolean
  ellipsis?: boolean
  hideManufacturer?: boolean
  hTag?: HeadingProps['hTag']
  lines?: number
}

const Title = ({ digitalDataIndex, digitalDataOrigin, ...other }: TitleProps) => (
  <ProductCardTitle
    onClickProduct={() =>
      handeOnClickProduct(digitalDataOrigin, other.product as any, digitalDataIndex)
    }
    {...other}
  />
)

export default Title
